import React from 'react';
import styled from 'styled-components';

import { TextField } from '@material-ui/core';

import { textTypes } from '../../../constants/styles';

const Input = styled(TextField)`
  margin-bottom: 26px;
  margin-right: 16px;
  .MuiFormHelperText-root {
    ${textTypes['Caption-w400']}
    color: var(--gray700);
    margin-top: 8px;
    margin-left: 0px;
  }
  label {
    &.Mui-focused,
    &.MuiInputLabel-outlined.MuiInputLabel-shrink {
      transform: translate(13px, -9px) scale(0.9) !important;
    }
  }
  p.MuiFormHelperText-root {
    ${({ theme }) => theme.textTypes['Overline-w400']}
    &.Mui-error {
      font-size: 12px;
    }
  }
  ${({ theme }) => theme.breakpoint('md')} {
    /* comboBox */
    .MuiInputBase-root {
      padding: 18.5px 16px;
      input {
        padding: 0 !important;
      }
    }
    /* input */
    input {
      padding: 14px 16px;
      height: 21px;
    }
    label {
      transform: translate(14px, 17px) scale(1);
    }
  }
`;

export default (props) => <Input id={props.id || 'input-text'} {...props} />;
